(function () {
  if (window.__velvetyCardProductBound) return;
  window.__velvetyCardProductBound = true;

  document.addEventListener('click', function (e) {
    // Colour swatch on the product card swaps the card's primary image
    // to the variant image carried on the swatch (issue #4). Clicking
    // doesn't navigate — it stays on the listing page so the shopper
    // can compare colours in place.
    const swatch = e.target.closest('[data-velvety-swatch]');
    if (swatch) {
      e.preventDefault();
      e.stopPropagation();
      const card = swatch.closest('[data-velvety-card]');
      if (!card) return;
      const img = card.querySelector('[data-velvety-card-image]');
      const imageUrl = swatch.getAttribute('data-velvety-swatch-image');
      if (img && imageUrl) {
        img.src = imageUrl;
        img.removeAttribute('srcset'); // single-resolution swap is fine here
      } else if (img) {
        // No variant-specific image — revert to the product default.
        const def = img.getAttribute('data-default-src');
        if (def) img.src = def;
      }
      card.querySelectorAll('[data-velvety-swatch]').forEach(function (s) {
        s.classList.toggle('is-active', s === swatch);
      });
      return;
    }

    const sizeBtn = e.target.closest('[data-velvety-quick-add-size]');
    if (sizeBtn) {
      if (sizeBtn.disabled || sizeBtn.classList.contains('is-loading')) return;
      e.preventDefault();
      e.stopPropagation();
      // Size chip is a SELECTOR, not an add-to-cart trigger. Mark the
      // clicked chip as the selected size for its card; the bag button
      // is what actually adds the variant to bag.
      selectSize(sizeBtn);
      return;
    }

    const bagBtn = e.target.closest('[data-velvety-card-bag]');
    if (bagBtn) {
      if (bagBtn.disabled || bagBtn.classList.contains('is-loading')) return;
      e.preventDefault();
      e.stopPropagation();

      const hasOptions = bagBtn.getAttribute('data-has-options') === 'true';
      const card = bagBtn.closest('[data-velvety-card]');
      const sizes = card ? card.querySelector('[data-velvety-quick-add]') : null;

      if (hasOptions && sizes) {
        // Use the chip the shopper picked. Fall back to the first
        // available chip when no explicit pick has happened yet, so a
        // one-click flow still works without scrolling/UI noise.
        var picked = sizes.querySelector('[data-velvety-quick-add-size].is-selected:not([disabled]):not(.is-unavailable)') ||
                     sizes.querySelector('[data-velvety-quick-add-size]:not([disabled]):not(.is-unavailable)');
        if (!picked) {
          // Nothing available — pulse the row + bail out with a soft hint.
          sizes.classList.remove('is-pulse');
          void sizes.offsetWidth;
          sizes.classList.add('is-pulse');
          return;
        }
        // Keep the bag button's loading state in sync with the variant
        // we're actually adding.
        bagBtn.setAttribute('data-variant-id', picked.getAttribute('data-variant-id'));
        addToCart(bagBtn);
        return;
      }

      addToCart(bagBtn);
    }
  });

  /* Single-select model for a card's size row. Adds .is-selected to
     the picked chip + sets aria-pressed for screen readers; clears the
     state on every other chip in the same row. The bag button reads
     this on add-to-cart. */
  function selectSize(btn) {
    var sizes = btn.closest('[data-velvety-quick-add]');
    if (!sizes) return;
    sizes.querySelectorAll('[data-velvety-quick-add-size]').forEach(function (b) {
      var isPicked = b === btn;
      b.classList.toggle('is-selected', isPicked);
      b.setAttribute('aria-pressed', isPicked ? 'true' : 'false');
    });
  }

  function addToCart(btn) {
    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.classList.add('is-loading');
    btn.disabled = true;

    /* Use the velvety-cart-drawer section id by default. Dawn's
       cart-drawer.renderContents() can't be used here — it derefs a
       `.drawer__inner` the Velvety drawer markup omits and throws. We
       request the same section ('cart-drawer') and inject the returned
       HTML via VelvetyCartDrawer.inject(), then open the drawer. */
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    const cartAddUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (data) {
        var sectionHtml = data && data.sections && data.sections['cart-drawer'];
        if (window.VelvetyCartDrawer && sectionHtml) {
          window.VelvetyCartDrawer.inject(sectionHtml);
          window.VelvetyCartDrawer.refreshHeaderBubble();
          window.VelvetyCartDrawer.open();
          return;
        }
        /* Fallback: no velvety drawer api (script not yet loaded) — refresh
           the cart bubble best-effort and stay on the page rather than
           redirecting away. */
        window.location.reload();
      })
      .catch(function () {
        /* Hard fallback: take the shopper to the product page with the
           chosen variant pre-selected so they can retry from the PDP. */
        const url = btn.getAttribute('data-product-url');
        if (url) window.location.href = url + '?variant=' + variantId;
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  }
})();
